import api from "../apis/api";

class OnLoadFunctionService {
    checkIsCompanyAvailable(req) {
        return api.onloadfunction.checkIsCompanyAvailable(req);
    }

    getPrivacyPolicy(req) {
        return api.onloadfunction.getPrivacyPolicy(req);
    }

    getCountryList() {
        return api.onloadfunction.getCountryList();
    }

    inviteParticipant(req) {
        return api.onloadfunction.inviteParticipant(req);
    }

    sessionStats(req) {
        return api.onloadfunction.sessionStats(req);
    }
}

export default new OnLoadFunctionService();
